import React, { useState } from "react";

import { Tooltip } from "@my-scoot/component-library-legacy";

import { DataItem } from "../DataItem";

import { IconButton } from "@material-ui/core";

import CopyIcon from "assets/images/copy.svg";
import EmailIcon from "assets/images/email.svg";

import { EditRounded as EditIcon } from "@material-ui/icons";
import DeleteRoundedIcon from "@material-ui/icons/DeleteRounded";
import VisibilityIcon from "@material-ui/icons/Visibility";

import classnames from "classnames";
import {
  CAMPAIGN_DESCRIPTIONS,
  CAMPAIGN_TYPES,
  EMAIL_TYPES,
} from "ui/pages/communications/CustomEmail/data";
import { campaignStepsData } from "../../utils";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import { ExlyImage } from "@my-scoot/exly-react-component-lib";
import FooterDataItem from "../FooterDataItem";
import {
  DRIP_SOURCE,
  POPOVER_TEXT,
  STATS_FIELDS,
} from "../../EmailListItem.constants";
import {
  getPercentage,
  formatRevenue,
} from "features/Common/utils/common.utils";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import SeeMoreStatsModal from "ui/pages/limitedOffer/seeMoreStatsModal";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import { useRefreshStats } from "utils/hooks/useRefreshStats";
import { statsColumns } from "ui/pages/limitedOffer/seeMoreStatsModalConfig";
import CircularProgress from "@material-ui/core/CircularProgress";
import RefreshIcon from "@material-ui/icons/Refresh";

const campaignStepColors = {
  campaignAdded: "tw-bg-[#493AB1]",
  campaignProcessing: "tw-bg-[#FFAB00]",
  campaignFailed: "tw-bg-[#BF2600]",
  campaignCompleted: "tw-bg-[#00B779]",
  campaignInsufficientCredits: "tw-bg-[#FC8542]",
};

const DesktopRow = ({
  alternate,
  email,
  recepients,
  type,
  subject,
  time,
  edit,
  onViewEditClick,
  onDuplicateClick,
  onDelete,
  hasWriteAccess,
}) => {
  const [openTooltipId, setOpenTooltipId] = useState(null);
  const [showStatsModal, setShowStatsModal] = useState(false);
  const { handleRefreshStats, loading: refreshLoading } = useRefreshStats();

  const { campaign_step, campaign_type, added_by_name } = email;

  const getTimePrefix = () => {
    if (type === EMAIL_TYPES.SCHEDULED)
      return <span className="tw-text-[#FFAA00]">Scheduled For</span>;
    if (type === EMAIL_TYPES.DRAFT) return "Edited";
    return campaign_type === CAMPAIGN_TYPES.NEW
      ? "Campaign start time:"
      : "Sent";
  };

  const openRate = getPercentage(email.opened_count, email.sent_to_count); // open rate - total number of emails opened/ total number of emails sent
  const clickRate = getPercentage(email.total_clicks, email.sent_to_count); // click rate - people that clicked any link in the email/ total number of emails sent

  return (
    <>
      <div
        className={classnames(
          "tw-flex tw-flex-col tw-pt-0 tw-pb-4 tw-pr-4 tw-pl-3 tw-border-[1.5px] tw-border-solid tw-border-[#E7E6E4] tw-rounded-lg tw-font-helvetica",
          alternate && "tw-bg-[#F3F2F1]",
          !hasWriteAccess && "disable_pointer"
        )}
      >
        <div className="tw-flex tw-flex-row tw-justify-between tw-border-b tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-[#E7E6E4]">
          <div className="tw-flex tw-flex-row tw-items-center">
            <ExlyImage
              className="tw-h-6 tw-w-6 tw-pr-3 tw-box-content"
              src={EmailIcon}
              alt="email"
            />

            <div className="tw-flex tw-gap-5 tw-text-[16px] tw-font-medium">
              <div
                className="tw-text-[#272522] tw-text-[16px] tw-underline tw-font-medium tw-cursor-pointer hover:tw-text-[#493AB1] hover:tw-underline"
                onClick={onViewEditClick}
              >
                To: {recepients}
              </div>

              {type === EMAIL_TYPES.DRAFT && (
                <div className="tw-h-[23px] tw-flex tw-items-center tw-text-[12px] tw-px-1.5 tw-rounded-[11.5px] tw-no-underline tw-bg-[#F7D6D4] tw-text-[#AA2822]">
                  draft
                </div>
              )}
              {type === EMAIL_TYPES.SCHEDULED && (
                <div className="tw-h-[23px] tw-flex tw-items-center tw-text-[12px] tw-px-1.5 tw-rounded-[11.5px] tw-no-underline tw-bg-[#FFEECC] tw-text-[#FFAA00]">
                  Scheduled
                </div>
              )}
            </div>
          </div>

          <div className="tw-flex tw-items-center">
            <Tooltip arrow color="primary" placement="top" title="View email">
              <IconButton className="!tw-p-3" onClick={onViewEditClick}>
                {edit ? <EditIcon /> : <VisibilityIcon />}
              </IconButton>
            </Tooltip>
            <Tooltip
              arrow
              color="primary"
              placement="top"
              title="Duplicate this email"
            >
              <IconButton className="!tw-p-3" onClick={onDuplicateClick}>
                <ExlyImage className="tw-h-[18px]" src={CopyIcon} alt="" />
              </IconButton>
            </Tooltip>
            <IconButton
              className="!tw-p-3 hover:tw-text-[#BF2600]"
              onClick={onDelete}
            >
              <DeleteRoundedIcon />
            </IconButton>
          </div>
        </div>

        <div className="tw-w-full">
          <div className="tw-flex tw-justify-between">
            <div className="tw-flex-1 tw-pt-[10px] tw-pb-[5px] tw-pr-0 tw-pl-10 tw-text-[16px] tw-font-normal">
              <div className="tw-text-[#272522] tw-text-[16px] tw-font-normal tw-mb-[10px]">
                Subject: {subject}
              </div>

              {time ? (
                <div className="tw-text-[14px] tw-text-[#272522]">
                  {getTimePrefix()} {time}
                </div>
              ) : (
                <div className="tw-text-[14px] tw-text-[#272522]">
                  Campaign to be processed
                </div>
              )}
            </div>

            <div className="-tw-mt-3 tw-flex tw-flex-col tw-justify-between">
              {campaign_type === CAMPAIGN_TYPES.NEW &&
                type === EMAIL_TYPES.SCHEDULED && (
                  <div className="tw-flex tw-gap-4 tw-mr-4 tw-items-center">
                    <Tooltip
                      arrow
                      color="primary"
                      placement="top"
                      title={CAMPAIGN_DESCRIPTIONS[campaign_step]}
                    >
                      <InfoIcon />
                    </Tooltip>
                    <Tooltip
                      arrow
                      color="primary"
                      placement="top"
                      title={added_by_name ? `Added by ${added_by_name}` : ""}
                    >
                      <div
                        className={classnames(
                          "tw-rounded-[14px] tw-flex tw-text-[12px] tw-py-1.5 tw-px-2 tw-gap-1 tw-text-center tw-text-white",
                          campaignStepColors[
                            campaignStepsData[campaign_step].className
                          ]
                        )}
                      >
                        {campaignStepsData[campaign_step].label}
                      </div>
                    </Tooltip>
                  </div>
                )}
            </div>
          </div>

          {type === EMAIL_TYPES.PAST && (
            <>
              <hr className="tw-border-none tw-h-[2px] tw-bg-[#E7E6E4] tw-my-[10px]" />

              <div className="tw-flex tw-justify-between tw-items-end tw-pl-10">
                <div className="tw-flex tw-gap-4">
                  <DataItem
                    dataClassName="tw-text-[#493AB1]"
                    title={STATS_FIELDS.sentTo}
                    data={email?.sent_to_count ?? 0}
                  />
                  <div className="tw-w-[1.5px] tw-bg-[#C4C4C4]" />
                  <DataItem
                    dataClassName="tw-text-[#00B77A]"
                    title={STATS_FIELDS.openedBy}
                    data={email?.opened_count ?? 0}
                  />
                  <div className="tw-w-[1.5px] tw-bg-[#C4C4C4]" />
                  <DataItem
                    dataClassName="tw-text-[#0052CC]"
                    title={STATS_FIELDS.openedRate}
                    subData={email?.opened_count ?? 0}
                    data={openRate}
                  />

                  <div className="tw-w-[1.5px] tw-bg-[#C4C4C4]" />
                  <div className="tw-flex tw-items-end tw-gap-4">
                    <DataItem
                      dataClassName="tw-text-[#0052CC]"
                      subData={email?.total_clicks ?? 0}
                      title={STATS_FIELDS.clickRate}
                      data={clickRate}
                      tooltipId="click_rate"
                      tooltipTitle={POPOVER_TEXT}
                      openTooltipId={openTooltipId}
                      setOpenTooltipId={setOpenTooltipId}
                    />
                    <div
                      className="tw-flex tw-items-center tw-text-[16px] tw-self-end tw-text-[#493AB1] tw-font-medium tw-cursor-pointer hover:tw-underline tw-whitespace-nowrap"
                      onClick={() => setShowStatsModal(true)}
                    >
                      <span>See more</span>
                      <KeyboardArrowRightIcon style={{ fontSize: 20 }} />
                    </div>
                  </div>
                </div>

                <div className="tw-flex tw-gap-4 tw-mr-4 tw-items-center">
                  <div className="tw-flex">
                    <FooterDataItem
                      dataClassName="tw-text-[#493AB1]"
                      titleClassName="tw-text-[#493AB1]"
                      title="Bookings"
                      data={email?.total_bookings_received ?? 0}
                    />
                    <div className="tw-w-[1.5px] tw-bg-[#C4C4C4] tw-mx-[22px]" />
                    <FooterDataItem
                      dataClassName="tw-text-[#00B77A]"
                      titleClassName="tw-text-[#00B77A]"
                      title="Revenue"
                      data={formatRevenue(email?.total_revenue)}
                    />
                  </div>
                  {campaign_type === CAMPAIGN_TYPES.NEW && (
                    <>
                      <Tooltip
                        arrow
                        color="primary"
                        placement="top"
                        title={added_by_name ? `Added by ${added_by_name}` : ""}
                      >
                        <div
                          className={classnames(
                            "tw-rounded-[14px] tw-flex tw-text-[12px] tw-py-1.5 tw-px-2 tw-gap-1 tw-text-center tw-text-white",
                            campaignStepColors?.[
                              campaignStepsData?.[campaign_step]?.className
                            ]
                          )}
                        >
                          {campaignStepsData?.[campaign_step]?.label}

                          <Tooltip
                            arrow
                            color="primary"
                            placement="top"
                            title={CAMPAIGN_DESCRIPTIONS[campaign_step]}
                          >
                            <InfoIcon style={{ fontSize: "16px" }} />
                          </Tooltip>
                        </div>
                      </Tooltip>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <ExlyModal
        desktopModalWidth="450px"
        className="!tw-px-5"
        open={showStatsModal}
        onClose={() => setShowStatsModal(false)}
        title="All stats and details"
        customFooter={
          <div className="tw-w-full tw-p-4">
            <button
              className="tw-w-full tw-border-none tw-flex tw-items-center tw-justify-center tw-gap-2 tw-bg-[#493AB1] tw-text-white tw-rounded-md tw-py-2 tw-font-medium"
              disabled={refreshLoading}
              onClick={() =>
                handleRefreshStats({
                  isWhatsApp: false,
                  campaignUuid: email?.email_key,
                })
              }
            >
              <p>Refresh stats</p>
              {refreshLoading ? (
                <CircularProgress size={18} color="inherit" />
              ) : (
                <RefreshIcon style={{ fontSize: 18 }} />
              )}
            </button>
          </div>
        }
      >
        <SeeMoreStatsModal
          record={email}
          columns={statsColumns(email)}
          isShowRefreshStat
          emailRetryText
          dripSource={DRIP_SOURCE.SALES_AND_MARKETING}
        />
      </ExlyModal>
    </>
  );
};

export default DesktopRow;
